import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	Typography,
	Box
} from '@mui/material'
import DownloadIcon from '@mui/icons-material/Download'

interface MovementDetailsModalProps {
	open: boolean
	onClose: () => void
	movement: any
	onDownloadFile: (filePath: string) => Promise<void>
	getTipoMovimiento: (action: string) => string
}

export const MovementDetailsModal = ({
	open,
	onClose,
	movement,
	onDownloadFile,
	getTipoMovimiento
}: MovementDetailsModalProps) => {
	if (!movement) return null

	return (
		<Dialog open={open} onClose={onClose} fullWidth>
			<DialogTitle>Detalle del Movimiento de {getTipoMovimiento(movement.action)}</DialogTitle>
			<DialogContent dividers>
				<Box>
					<Typography>
						<strong>Fecha:</strong> {new Date(movement.date).toLocaleDateString()}
					</Typography>
					<Typography>
						<strong>Usuario:</strong> {movement.user}
					</Typography>
					<Typography>
						<strong>Cantidad:</strong> {movement.mount}
					</Typography>
					<Typography>
						<strong>No. Egreso:</strong> {movement.outcomeNumber}
					</Typography>

					{movement.action === 'sale' && movement.sale && (
						<>
							<Typography>
								<strong>Cliente:</strong> {movement.sale.clientName}
							</Typography>
							<Typography>
								<strong>NIT:</strong> {movement.sale.nit}
							</Typography>
							<Typography>
								<strong>Factura:</strong> {movement.sale.invoice}
							</Typography>
							<Typography>
								<strong>Piloto:</strong> {movement.sale.driver}
							</Typography>
							<Typography>
								<strong>Placa:</strong> {movement.sale.plateNumber}
							</Typography>
						</>
					)}

					{movement.action === 'donation' && movement.donation && (
						<>
							<Typography>
								<strong>Beneficiario:</strong> {movement.donation.clientName}
							</Typography>
							<Typography>
								<strong>Documento:</strong> {movement.donation.document}
							</Typography>
						</>
					)}

					{movement.action === 'transfer' && movement.transfer && (
						<>
							<Typography>
								<strong>Programa:</strong> {movement.transfer.program}
							</Typography>
							<Typography>
								<strong>Centro:</strong> {movement.transfer.center}
							</Typography>
							<Typography>
								<strong>Guía de Envío:</strong> {movement.transfer.shipment}
							</Typography>
						</>
					)}

					<Typography>
						<strong>Notas:</strong> {movement.notes}
					</Typography>

					{movement.attachments && movement.attachments.length > 0 && (
						<Box mt={2}>
							<Typography>
								<strong>Archivos Adjuntos:</strong>
							</Typography>
							<ul>
								{movement.attachments.map((attachment: string, index: number) => (
									<Typography key={index} component="li">
										{attachment.split('/').pop()}
										<Button
											variant="text"
											startIcon={<DownloadIcon />}
											style={{ marginLeft: '8px' }}
											onClick={() => onDownloadFile(attachment)}
										>
											Descargar
										</Button>
									</Typography>
								))}
							</ul>
						</Box>
					)}
				</Box>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>Cerrar</Button>
			</DialogActions>
		</Dialog>
	)
}
